module.exports = __webpack_public_path__ + "img/logo.6c2dd919.svg";